import { Box, Button, Flex, Title } from '@mantine/core';
import { BetaIcon, BetaText } from '../../../../lib/components';
import classes from './NewTable.module.css';

export type HeaderProps = {
  title?: string;
  onAdd?: () => void;
  action?: React.ReactNode;
  itemsLength?: number;
};

const Header = ({ title, action, itemsLength, onAdd }: HeaderProps) => {
  return (
    <Box className={classes.title}>
      <Flex gap="xs" align="baseline">
        <Title order={3} c="dark.0" fz={18}>
          {title}
        </Title>
        {!!itemsLength && <BetaText variant="b3">({itemsLength})</BetaText>}
      </Flex>
      {onAdd && (
        <Button
          variant="transparent"
          size="sm"
          onClick={onAdd}
          data-testid="add-button"
        >
          <BetaIcon icon="plus" />
        </Button>
      )}
      {!!action && action}
    </Box>
  );
};

export default Header;
